export enum MarketingActionTypes {
    LIST_REQUEST = '@@Marketing/LIST_REQUEST',
    LIST_SUCCESS = '@@Marketing/LIST_SUCCESS',
    LIST_ERROR = '@@Marketing/LIST_ERROR',
    LIST_CLEAR = '@@Marketing/LIST_CLEAR',

    SELECT = '@@Marketing/SELECT',
    SELECTED = '@@Marketing/SELECTED',
    CLEAR_SELECTED = '@@Marketing/CLEAR_SELECTED',
    
    CREATE_REQUEST = '@@Marketing/CREATE_REQUEST',
    CREATE_SUCCESS = '@@Marketing/CREATE_SUCCESS',
    CREATE_ERROR = '@@Marketing/CREATE_ERROR',
    
    // READ_REQUEST = '@@Marketing/READ_REQUEST',
    // READ_SUCCESS = '@@Marketing/READ_SUCCESS',
    // READ_ERROR = '@@Marketing/READ_ERROR',

    UPDATE_REQUEST = '@@Marketing/UPDATE_REQUEST',
    UPDATE_SUCCESS = '@@Marketing/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@Marketing/UPDATE_ERROR',
    
    DELETE_REQUEST = '@@Marketing/DELETE_REQUEST',
    DELETE_SUCCESS = '@@Marketing/DELETE_SUCCESS',
    DELETE_ERROR = '@@Marketing/DELETE_ERROR'
}

export interface MarketingUIState {
    readonly loading: boolean
    readonly searchParams?: any
    readonly processing: boolean // For CRUD Operation
    readonly processState: number
    readonly selected?: string
    readonly errors?: string []
    readonly isConflict : boolean
    readonly totDoc?: number
}
